import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';
import { MatDialog, MatDialogRef } from '@angular/material';
import { MonedaEditComponent } from '../moneda-edit/moneda-edit.component';

@Component({
  selector: 'app-moneda',
  templateUrl: './moneda.component.html',
  styleUrls: ['./moneda.component.css'],
  providers:[
    { provide: MatDialogRef,useValue: {} }
  ]
})
export class MonedaComponent implements OnInit {
  errMsg:any;
  loading:boolean = false;
  mons:any=[];

  constructor(private dataService: DataService, public dialogRef: MatDialogRef<MonedaEditComponent>, public dialog: MatDialog) { }

  ngOnInit() {
    this.fnIniciar();
  }

  fnIniciar(){
    this.loading = true;
    this.dataService.getMonedas().subscribe(
                      rows => {   
                              this.mons = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnMonedasCargadas());
  }

  fnMonedasCargadas(){
    //console.log(this.mons);
    this.loading = false;
  }

  fnEditar(mon){
    //console.log("Editar: " + mon.idMon);
    let dialogRef = this.dialog.open(MonedaEditComponent, {
                                      width: "600px",
                                      data: { 
                                            id:mon.idMon,
                                            item:mon
                                            }
                                    });
    dialogRef.afterClosed().subscribe(result => {
                                    //console.log("Popup cerrado");                                    
                                    this.fnIniciar();
                                    }); 
  }

  fnNuevo(){
    //console.log("Ingresar nuevo item");
    let dialogRef = this.dialog.open(MonedaEditComponent, {
                                      width: "600px",
                                      data: { 
                                            id:-1,
                                            item:{'tipo': null,
                                                  'nombre': null,
                                                  'valor': null,
                                                  'act': 1
                                                 }
                                            }
                                    });
    dialogRef.afterClosed().subscribe(result => {
                                    //console.log("Popup cerrado");
                                    this.fnIniciar();
                                    }); 
  }

}


